<template>
  <div class="moblieContent">
    <div class="moblieBox" ref="moblieBox">
      <div class="topInfo" ref="topInfo">
        <div class="div_shown_close_button" v-if="Boolean(showReturnButton)">
          <div class="div_close_button" @click="showCloseDialog">
            <span class="close-icon">✕</span>
          </div>
        </div>
        <div class="title">{{ $t("common.title") }}</div>
        <!-- <div class="changeLangBtn" @click="changeL(languageTitle)">
          <i></i>
          {{ languageTitle }}
        </div> -->
        <!-- 切换语言 -->
        <div class="div_select_right">
          <div class="mobile-language-selector">
            <div
              class="selected-language"
              @click="showLanguageOptions = !showLanguageOptions"
            >
              {{ languageTitle }} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="language-options" v-if="showLanguageOptions">
              <div
                v-for="item in language"
                :key="item.value"
                class="language-option"
                :class="{ active: languagekey === item.value }"
                @click="handleLanguageChange(item.value, item.text)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="amountInfo">
          <div class="moneyInfo">
            <span class="currency">{{ goodInfo.currencySymbol }}</span>
            <span class="totalfee">{{ goodInfo.totalFee }}</span>
          </div>
          <div class="timeInfo" v-if="timeInfoFlag">
            <span>{{ $t("common.timeInfoTitle") }}</span>
            {{ countDownList }}
          </div>
        </div>
        <div class="botLine"></div>
      </div>

      <!-- mol 容器 -->
      <!-- <div id="molpay_ebanking_fpx_MY-container"></div> -->

      <div class="fffContainer" ref="fffContainer">
        <!-- 商品信息 -->
        <div class="goodInfo" ref="goodInfo">
          <div class="title">{{ $t("common.goodName") }}</div>
          <div class="goodName">{{ goodInfo.goodsName }}</div>
          <div class="title">{{ $t("common.goodDes") }}</div>
          <div class="goodDes">{{ goodInfo.goodsDetail }}</div>
        </div>
        <div class="line"></div>
        <!-- 支付方式 -->
        <div class="payMethod">
          <div class="title">{{ $t("common.payMethods") }}</div>
          <div class="payAll">
            <van-radio-group v-model="checkoutValue">
              <van-cell-group :border="false">
                <div
                  v-for="(item, index) in goodInfo.payWayConfigList"
                  :key="index"
                >
                  <div
                    v-if="
                      (item.payWayCode == 9 && supportsApplePay()) ||
                        item.payWayCode != 9
                    "
                  >
                    <van-cell
                      v-if="
                        (item.curPayProductData.productCode !== 31 &&
                          item.curPayProductData.productCode !== 37 &&
                          item.curPayProductData.productCode !== 58) ||
                          (item.curPayProductData.productCode === 31 &&
                            showStripe) ||
                          (item.curPayProductData.productCode === 37 &&
                            !showStripe) ||
                          (item.curPayProductData.productCode === 58 &&
                            !showStripe)
                      "
                      :border="false"
                      @click="selectPay(item.curPayProductData.productCode)"
                    >
                      <template #title>
                        <div class="payPart clearfix">
                          <i class="l">
                            <img :src="item.logoUrl" />
                          </i>
                          <div class="text l">
                            <van-cell
                              center
                              :title="item.payWayName"
                              lable="asdasd"
                            />
                          </div>
                        </div>
                      </template>
                      <template #right-icon>
                        <van-radio
                          class="radioBox"
                          :name="item.curPayProductData.productCode"
                        />
                      </template>
                    </van-cell>
                  </div>
                  <!-- 如果是选中FPX支付 -->
                  <!-- <div v-if="item.payProduct == 46 && checkoutValue == 46">
                    <p class="mol_tip" v-if="fpxPaymentMethod">{{fpxPaymentMethod.issuer}}</p>
                </div> -->
                  <p
                    class="tip"
                    v-if="
                      item.curPayProductData.productCode === 31 && showStripe
                    "
                  >
                    请使用微信扫一扫付款。注：请勿在微信内长按识别二维码，或扫描本地相册的二维码。
                  </p>
                </div>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>
      </div>
      <!-- 支付失败弹窗 -->
      <van-dialog
        class="dialogBox"
        v-model="dialogShow"
        :confirmButtonText="$t('moblie.modalConfirm')"
        confirmButtonColor="#FFAA0A"
        :overlay="true"
        @confirm="dialogShow = false"
      >
        <img
          :src="require('../../assets/mobile/' + srcPath + '.png')"
          width="160"
        />
        <p>{{ failText }}</p>
      </van-dialog>
    </div>
    <!-- test -->
    <!-- <div ref="cardContainer" id="AirwallexCard"></div>
<button id="submit" @click="handlePayment">Submit</button> -->
    <!-- test -->
    <!-- 支付按钮 -->
    <div class="payBtnBox">
      <div class="payBtn" @click="goPay">
        {{ $t("common.payConfirm") }}
        <span style="margin-left:0.08rem">{{ goodInfo.currencySymbol }}</span>
        {{ goodInfo.totalFee }}
      </div>
    </div>
    <!-- paynow支付 -->
    <van-action-sheet
      v-if="isShowPaynowSheet"
      v-model="isShowPaynowSheet"
      class="paynow-action-sheet"
    >
      <div class="header">
        <div class="div_left">
          <img :src="logoInfo.path" alt width="56" />
          {{ logoInfo.name }}
        </div>
        <div class="div_right" @click="closePayResult">
          <span></span>
        </div>
      </div>
      <div class="centerContent">
        <div ref="qrcodeRef"></div>
        <div class="botText" style="margin-top:14px;">
          {{ $t("moblie.paynowScanCodeNormal1") }}
          <span>{{ $t("moblie.paynowScanCodeApp") }}</span>
          {{
            languageTitle == "English" ? $t("moblie.paynowScanCodeNormal2") : ""
          }}
        </div>
        <div class="botText" v-if="languageTitle == 'English'">
          {{ $t("moblie.paynowScanCodeNormal3") }}
        </div>
      </div>
    </van-action-sheet>
    <!-- pop弹窗 -->
    <van-popup
      v-model="FpxPopupShow"
      round
      closeable
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div class="popup-content">
        <div class="popup-title">{{ $t("moblie.popupTitle") }}</div>
        <div id="molpay_ebanking_fpx_MY-container"></div>
      </div>
    </van-popup>
    <van-popup
      v-model="googleOApplePayShow"
      get-container="body"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="googleOrApplePayButton-wrap">
        <p class="tips">请点击按钮支付</p>
        <img
          class="loading-img"
          v-if="loading"
          src="../../assets/pc/tal_button_loading_black.png"
          alt
        />
        <div class="googleOrApplePayButton" id="googleOrApplePayButton"></div>
      </div>
    </van-popup>
    <!-- stripe express checkout -->
    <van-popup
      v-model="stripeExpressCheckoutPopupShow"
      get-container="body"
      closeable
      close-icon="close"
      position="center"
      :style="{ height: '200px', width: '320px', borderRadius: '10px' }"
    >
      <div class="stripeExpressCheckoutButton-wrap">
        <p class="tips">请点击按钮支付</p>
        <img
          class="loading-img"
          v-if="loading"
          src="../../assets/pc/tal_button_loading_black.png"
          alt
        />
        <div class="stripeExpressCheckoutButton" id="stripeExpressCheckoutButton"></div>
      </div>
    </van-popup>

    <!-- Airwallex卡支付 -->
    <airwallex-payment
      v-model="airwallexPopupShow"
      :responseData="airwallexResponseData"
      :client-secret="clientSecret"
      :amount="goodInfo.totalFee"
      :currency="goodInfo.currency"
      :environment="goodInfo.airwallexEnv === 'LIVE' ? 'prod' : 'demo'"
      :is-mobile="true"
      @payment-success="handleAirwallexSuccess"
      @payment-error="handleAirwallexError"
      @initialized="handleAirwallexInitialized"
      @report-log="reportLog"
    />
  </div>
</template>
<script>
import "@/style/moblie/reset.css";
import api from "@/api/api";
import { Notify, Toast } from "vant";
import utils from "@/utils/index";
import { Base64 } from "js-base64";
import indexMixin from "../../mixins/index";
import * as QRCode from "easyqrcodejs";
import AirwallexPayment from "@/components/AirwallexPayment.vue";
// import {Airwallex} from "airwallex-payment-elements";
// import { createElement, loadAirwallex, getElement, confirmPaymentIntent } from 'airwallex-payment-elements';

const CMB_PAY_URL =
  location.host.indexOf("checkout") === 0
    ? "https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_EUserPay"
    : "http://121.15.180.66:801/netpayment/BaseHttp.dll?MB_EUserPay";
export default {
  components: {
    AirwallexPayment
  },
  data() {
    return {
      payProductH5List: [
        42,
        30,
        31,
        37,
        38,
        39,
        44,
        46,
        11,
        27,
        12,
        20,
        28,
        25,
        5,
        3,
        51,
        49,
        58,
        59,
        61,
        63,
        69,
        72,
        75,
        78
      ],
      language: [
        { text: "English", value: "0" },
        { text: "简体中文", value: "1" },
        { text: "Français", value: "2" },
        { text: "日本語", value: "3" },
        { text: "한국어", value: "4" }
      ],
      languageTitle: "English",
      languagekey: "0",
      showLanguageOptions: false,
      countDownList: "00:00:00",
      timeInfoFlag: false,
      dialogShow: false,
      srcPath: "payment_failure_move",
      failText: "",
      actEndTime: "",
      checkoutValue: "",
      goodInfo: {},
      queryStatusFlag: "",
      isShowPaynowSheet: false,
      paynowImg: require("../../assets/mobile/paynowLogo.png"),
      logoInfo: {
        path: "",
        name: ""
      },
      interval: null,
      returnUrl: "",
      FpxPopupShow: false,
      fpxType: "",
      fpxName: "",
      issuers: [],
      onlineBankingMalaysiaComponent: null,
      fpxPaymentMethod: null,
      highlightedIssuers: [],
      clientKey: "",
      environment: "",
      cardElement: null,
      airwallexPopupShow: false,
      airwallexResponseData: {},
      cardNumber: null,
      expiry: null,
      cvc: null,
      domElement: null,
      countryCode: "",
      clientSecret: "",
      googleOApplePayShow: false,
      payTradeNo: "",
      loading: false,
      bankAccountListToken: "",
      changeLanguageTimer: null,
      isQueryingOrder: false,
      isFromPayment: false,
      showReturnButton: 0,
      cancelUrl: "",
      stripeExpressCheckoutPopupShow: false,
      stripePublishableKey: "",
      merchantName: "",
      amount: 0,
      currency: ""
    };
  },

  mounted() {
    this.init();
    // 上报数据
    this.reportLog({
      eventId: "PAGE_LOAD_H5",
      msg: ""
    });
  },
  computed: {
    // 判断展示stripe的微信扫码支付 还是微信公众号支付
    showStripe() {
      // 微信外 stripe的微信扫码支付
      if (!this.isInWeixin()) {
        return true;
      } else {
        // 微信内
        // 若同时存在stripe的微信扫码支付和adyen的公众号支付或者airwallex的公众号支付，只展示adyen的公众号支付或者airwallex的公众号支付
        // 若只存在adyen的公众号支付，则展示adyen的公众号支付
        // 若只存在stripe的微信扫码支付，则展示stripe的微信扫码支付
        // 总结： 有adyen的公众号支付或者airwallex的公众号支付就展示，没有则展示扫码
        const hasWeixinPay = this.goodInfo.payWayConfigList.find(
          item =>
            item.curPayProductData.productCode === 37 ||
            item.curPayProductData.productCode === 58
        );
        if (hasWeixinPay) {
          return false;
        }
        return true;
      }
    }
  },
  mixins: [indexMixin],
  methods: {
    /**
     * @method sanitizeAndValidateUrl
     * @description 清理和验证URL，处理各种可能的URL格式问题
     * @param {String} url 原始URL
     * @returns {String|null} 处理后的有效URL，如果无法修复则返回null
     */
    sanitizeAndValidateUrl(url) {
      if (!url || typeof url !== "string") {
        return null;
      }

      let processedUrl = url.trim();

      try {
        // 处理多重URL编码
        let decodedUrl = processedUrl;
        let maxDecodeAttempts = 3; // 最多尝试解码3次，防止无限循环

        for (let i = 0; i < maxDecodeAttempts; i++) {
          try {
            const decoded = decodeURIComponent(decodedUrl);
            if (decoded === decodedUrl) {
              break; // 如果解码后没有变化，说明已经完全解码
            }
            decodedUrl = decoded;
          } catch (e) {
            break; // 解码失败，使用当前结果
          }
        }

        processedUrl = decodedUrl;

        // 添加协议前缀（如果缺失）
        if (!/^https?:\/\//i.test(processedUrl)) {
          processedUrl = "https://" + processedUrl;
        } else if (processedUrl.startsWith("http://")) {
          processedUrl = processedUrl.replace("http://", "https://");
        }
        // 使用原生URL构造函数验证URL格式
        const urlObj = new URL(processedUrl);

        // 基本安全检查
        const hostname = urlObj.hostname.toLowerCase();

        // 检查是否为有效的域名格式
        const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!domainRegex.test(hostname)) {
          console.warn("Invalid domain format:", hostname);
          return null;
        }

        // 防止一些常见的恶意URL
        const blockedPatterns = [
          /^javascript:/i,
          /^data:/i,
          /^vbscript:/i,
          /^file:/i
        ];

        for (const pattern of blockedPatterns) {
          if (pattern.test(processedUrl)) {
            console.warn("Blocked potentially dangerous URL:", processedUrl);
            return null;
          }
        }
        return urlObj.toString();
      } catch (error) {
        console.warn(
          "URL validation failed:",
          error.message,
          "for URL:",
          processedUrl
        );
        return null;
      }
    },
    /**
     * @method showCloseDialog
     * @description 点击关闭按钮，跳转到 cancelUrl
     */
    showCloseDialog() {
      if (this.cancelUrl) {
        // 跳转到业务方传入的 cancelUrl
        const sanitizedUrl = this.sanitizeAndValidateUrl(this.cancelUrl);

        if (sanitizedUrl) {
          try {
            // 使用 window.open 在当前窗口跳转
            window.open(sanitizedUrl, "_self");
          } catch (error) {
            console.error("Failed to navigate to URL:", error);
            Notify({
              type: "danger",
              message: "跳转失败，URL格式错误"
            });
          }
        } else {
          // URL验证失败
          console.error("Invalid cancelUrl:", this.cancelUrl);
          Notify({
            type: "danger",
            message: "跳转失败，URL格式不正确"
          });
        }
      } else {
        // 如果没有 cancelUrl，则执行默认的返回操作
        Notify({
          type: "danger",
          message: "跳转失败，请稍后重试"
        });
      }
    },
    /**
     * @method airwallexInit
     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 银行支付
     */
    // initializeAirwallex() {
    //   loadAirwallex({
    //     env: 'demo', // Can choose other production environments, 'staging | 'demo' | 'prod'
    //     origin: window.location.origin, // Setup your event target to receive the browser events message
    //   }).then(() => {
    //     this.cardNumber = createElement("cardNumber");
    //     this.expiry = createElement("expiry");
    //     this.cvc = createElement("cvc");
    //     this.domElement = this.cardNumber.mount("cardNumber");
    //     this.expiry.mount("expiry");
    //     this.cvc.mount("cvc");
    //   });
    // },
    /**
     * @method handlePayment
     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 银行支付
     */
    // async handlePayment() {
    //   confirmPaymentIntent({
    //     element: this.cardNumber,
    //     id: "replace-with-your-intent-id",
    //     client_secret: "replace-with-your-client-secret"
    //   }).then(response => {
    //     window.alert(JSON.stringify(response));
    //   });
    // },
    /**
     * @method AdyenCheckoutInit
     * @param {string} title adyen配置
     * @description fpx支付
     */
    async AdyenCheckoutInit() {
      let _this = this;
      // 初始化adyencheckout
      let paymentMethodsArray = [];
      paymentMethodsArray.push({
        type: this.fpxType,
        name: this.fpxName,
        issuers: this.issuers
      });
      // 将this.issuers的disable字段设置为true
      this.issuers.map((item, i) => {
        if (i == 1) {
          item.disabled = true;
        }
      });
      this.issuers.map(item => {
        this.highlightedIssuers.push(item.id);
      });
      // const AdyenCheckout = .AdyenCheckout;
      console.log(window.AdyenCheckout, "AdyenCheckout");
      const configuration = {
        paymentMethodsResponse: {
          paymentMethods: paymentMethodsArray
        },
        analytics: {
          enabled: true // Set to false to not send analytics data to Adyen.
        },
        showPayButton: false,
        environment: _this.environment, // Change to 'live' for the live environment.
        clientKey: _this.clientKey, //live_T536KAE6W5BTLPEQPFBAHMZZL4DHNHW4 Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        onPaymentCompleted: (result, component) => {
          console.log(result, component, "onPaymentCompleted");
        },
        onChange: (state, component) => {
          console.log(state, component, "onChange");
          _this.fpxPaymentMethod = state.data.paymentMethod;
          if (_this.fpxPaymentMethod.issuer) {
            _this.FpxPopupShow = false;
          }
        },
        onSubmit: (state, component) => {
          console.log(state, component, "onsubmit");
          // onlineBankingMalaysiaComponent.handleAction(state.data.paymentMethod);
        },
        onError: (error, component) => {
          console.error(error, component, "onError");
        }
      };
      // Remove the existing declaration of onlineBankingMalaysiaConfiguration
      // Move the declaration outside the block scope
      const onlineBankingMalaysiaConfiguration = {
        showImage: true, // Optional. Set to **false** to remove the bank logos from the Online banking Malaysia form.
        highlightedIssuers: this.highlightedIssuers // Optional. List of bank codes to highlight in the bank selection dialog.
      };
      const checkout = await new window.AdyenCheckout(configuration);
      _this.onlineBankingMalaysiaComponent = checkout
        .create("molpay_ebanking_fpx_MY", onlineBankingMalaysiaConfiguration)
        .mount("#molpay_ebanking_fpx_MY-container");

      // console.log(onlineBankingMalaysiaComponent, "dropinComponent=====");
    },
    // ach支付初始化
    achPaymentInit() {
      // 保存returnUrl，避免返回后找不到returnUrl
      let returnUrl = this.goodInfo.returnUrl;
      localStorage.setItem("ach_return_url", returnUrl || "");

      // 跳转到cardList页面
      this.$router.push(
        {
          path: "/achCardList",
          query: {
            checkoutToken: utils.getUrlSearch("checkoutToken"),
            payProduct: this.checkoutValue,
            businessCode: this.goodInfo.businessCode,
            bankAccountListToken: this.bankAccountListToken,
            environment: this.environment,
            merchantPayNo: utils.getUrlSearch("merchantPayNo"),
            clientKey: this.clientKey,
            currencySymbol: this.goodInfo.currencySymbol,
            totalFee: this.goodInfo.totalFee,
            language: this.$i18n.locale,
            returnUrl: this.returnUrl,
            merchantCode: this.goodInfo.merchantCode
          }
        },
        () => {
          console.log("导航到ACH卡列表页面成功");
        },
        err => {
          console.error("导航到ACH卡列表页面失败:", err);
          // 导航失败时可以显示提示
          Toast.fail("页面跳转失败，请重试");
        }
      );
    },
    /**
     * @method selectPay
     * @param {String} payCode 支付方式
     * @description 选择支付方式
     */
    selectPay(payCode) {
      console.log("select");
      this.checkoutValue = payCode;
      // 如果选择fpx支付
      if (payCode === 46) {
        this.AdyenCheckoutInit();
        this.FpxPopupShow = true;
      }
      // 如果是airwallex卡支付 - 暂不加载脚本，等点击支付时再加载
      if (payCode === 63) {
        // returnUrl赋值
        this.returnUrl = this.goodInfo.returnUrl;
        // 只记录选择，不立即加载脚本
      }
      // 如果是apple pay或者google pay
      if (payCode === 49 || payCode === 51) {
        // returnUrl赋值
        this.returnUrl = this.goodInfo.returnUrl;
      }
      // 如果是ach支付
      if (payCode === 61) {
        this.returnUrl = this.goodInfo.returnUrl;
      }
      if (payCode === 69 || payCode === 72) {
        this.returnUrl = this.goodInfo.returnUrl;
      }
      // 日志上报
      let params = {
        eventId: "PAYMETHOD_H5",
        msg: payCode
      };
      this.reportLog(params);
    },
    /**
     * @method handleLanguageChange
     * @param {string} value 语言值
     * @param {string} text 语言文本
     * @description 处理语言切换
     */
    handleLanguageChange(value, text) {
      // 直接设置语言，无需防抖
      this.languagekey = value;
      this.languageTitle = text;

      const languageMap = {
        "0": "en",
        "1": "zh",
        "2": "fr",
        "3": "ja",
        "4": "ko"
      };

      // 设置i18n语言
      this.$i18n.locale = languageMap[value];
      localStorage.setItem("lang", languageMap[value]);

      // 隐藏选项列表
      this.showLanguageOptions = false;

      // 日志上报
      let params = {
        eventId: "LANGUAGE_CHANGE_H5",
        msg: languageMap[value]
      };
      this.reportLog(params);
    },
    /**
     * @method setPayBoxH
     * @description 计算支付方式盒子的高度
     */
    async setPayBoxH() {
      this.$refs.fffContainer.style.height =
        this.$refs.moblieBox.offsetHeight -
        this.$refs.topInfo.offsetHeight +
        "px";
      console.log(
        this.$refs.moblieBox.offsetHeight,
        this.$refs.topInfo.offsetHeight,
        this.$refs.fffContainer.offsetHeight
      );
    },
    // 关闭paynow弹框
    closePayResult() {
      this.isShowPaynowSheet = false;
      this.interval && clearInterval(this.interval);
    },
    /**
     * @methods setGoodInfo
     * @description 获取页面信息
     */
    setGoodInfo() {
      let merchantPayNo =
        utils.getUrlSearch("merchantPayNo") || this.goodInfo.merchantOrderNo;
      let businessCode =
        utils.getUrlSearch("businessCode") || this.goodInfo.businessCode;
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      let ua = navigator.userAgent.toLowerCase();
      let params = {
        merchantPayNo: merchantPayNo,
        businessCode: businessCode,
        checkoutType: 0
      };
      this.showReturnButton =
        parseFloat(utils.getUrlSearch("showReturnButton")) || 0;
      this.cancelUrl = utils.getUrlSearch("cancelUrl") || "";

      // 微信环境下增加env参数
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        params["env"] = 1;
      }
      const loading = Toast.loading({
        message: this.$i18n.t("common.loadingCommonText"),
        forbidClick: true,
        duration: 0
      });
      api.apiMethod.checkoutShow
        .post(params, {
          checkoutToken: checkoutToken
        })
        .then(res => {
          // 指定关闭某一个loading
          loading.clear();
          if (res.data.code === 10000) {
            res.data.data.payWayConfigList =
              this.payWayConfigList(
                res.data.data.payWayConfigList,
                this.payProductH5List
              ) || [];
            this.goodInfo = res.data.data;
            console.log(this.goodInfo, "this.goodInfo====");
            if (this.goodInfo.payWayConfigList) {
              this.goodInfo.payWayConfigList.map(item => {
                // if (item.checked && item.platformType === 0) {
                //   this.checkoutValue = item.payProduct;
                // }
                // 如果是fpx支付，payProduct=46
                console.log(item.curPayProductData, "item.curPayProductData");
                if (item.curPayProductData.productCode === 46) {
                  this.issuers = item.curPayProductData.issuers;
                  this.fpxType = item.curPayProductData.type;
                  this.fpxName = item.curPayProductData.name;
                  this.clientKey = item.curPayProductData.adyenClientKey;

                  console.log(this.clientKey, "this.clientKey");
                  // 将clientKeyy以'_''分割，取第一个值
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                }
                // 如果是ach支付，payProduct=61
                if (item.curPayProductData.productCode === 61) {
                  this.bankAccountListToken =
                    item.curPayProductData.bankAccountListToken;
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                  this.clientKey = item.curPayProductData.adyenClientKey;
                }
              });
            }
            // 判断订单状态
            if (res.data.data.status === 1) {
              // 当初始化时订单状态为完成则直接跳转到订单成功页面
              this.returnUrl = res.data.data.returnUrl;
              this.payStatusResult(1);
            } else if (res.data.data.status === 2) {
              this.payStatusResult(2);
              // this.queryOrder();
            } else if (res.data.data.status === 3) {
              this.payStatusResult(3);
              // this.queryOrder();
            } else {
              // 开始轮询查询订单状态，但不显示loading（仅在从ACH支付返回时才显示loading）
              this.queryOrder(false);
              let nowTime =
                Math.abs(new Date().getTime() - this.goodInfo.nowTime) > 3000
                  ? this.goodInfo.nowTime
                  : new Date().getTime();
              if (this.goodInfo.specificTimeout) {
                this.timeInfoFlag = true;
                if (this.goodInfo.specificTimeout - nowTime > 0) {
                  this.countDown(
                    this.goodInfo.nowTime,
                    this.goodInfo.specificTimeout
                  );
                } else {
                  // 订单超时
                  this.payStatusResult(3);
                }
              }
            }
            this.setPayBoxH();
            // 上报数据
            let logParams = {
              eventId: "CONFIGSUCCESS_H5"
            };
            this.reportLog(logParams);
          } else {
            Notify({ type: "warning", message: res.data.subMsg });
            let logParams = {
              eventId: "CONFIGFAIL_H5"
            };
            this.reportLog(logParams);
          }
        });
    },
    /**
     * @method countDown
     * @description 根据服务器返回的超时时间算出倒计时
     */
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
    countDown(nowTime, endTime) {
      let newTime =
        Math.abs(new Date().getTime() - nowTime) > 3000
          ? nowTime
          : new Date().getTime();

      // 定义倒计时逻辑函数
      const updateCountDown = () => {
        // 获取当前时间，同时得到活动结束时间数组
        // 对结束时间进行处理渲染到页面
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let hou = parseInt(time / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
        } else {
          // 活动已结束，全部设置为'00'
          obj = {
            hou: "00",
            min: "00",
            sec: "00"
          };
          this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
          this.payStatusResult(3);
          clearInterval(interval);
          return false; // 返回 false 表示停止执行
        }
        this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
        newTime = newTime + 1000;
        return true; // 返回 true 表示继续执行
      };
      // 立即执行一次
      if (updateCountDown()) {
        // 如果第一次执行成功（没有到时间），则设置定时器继续执行
        var interval = setInterval(updateCountDown, 1000);
      }
    },
    /**
     * @method goPay
     * @description 点击支付
     */
    goPay() {
      let businessCode =
        utils.getUrlSearch("businessCode") || this.goodInfo.businessCode;
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      // this.stripePublishableKey = this.goodInfo.payWayConfigList.find(item => item.curPayProductData.productCode === this.checkoutValue).curPayProductData.stripePublishableKey || "";
      // this.merchantName = this.goodInfo.payWayConfigList.find(item => item.curPayProductData.productCode === this.checkoutValue).merchantName || "";
      // this.amount = this.goodInfo.totalFee;
      // this.countryCode = this.goodInfo.currency.toLowerCase();
      this.goodInfo.payWayConfigList.map(item => {
        if (item.curPayProductData.productCode === this.checkoutValue) {
          this.stripePublishableKey = item.curPayProductData.stripePublishableKey || "";
          this.merchantName = item.merchantName || "";
          this.countryCode = item.curPayProductData.countryCode || "";
        }
      });
      if (this.checkoutValue === 46) {
        // 如果没有选中银行卡
        if (!this.fpxPaymentMethod) {
          Notify({ type: "warning", message: this.$t("common.payMethods") });
          return false;
        }
        // 删掉不需要的字段
        delete this.fpxPaymentMethod.checkoutAttemptId;
        this.extendParam = JSON.stringify(this.fpxPaymentMethod);
      }
      // 如果是ach支付
      if (this.checkoutValue === 61) {
        this.achPaymentInit();
        return false;
      }
      if (!this.checkoutValue) {
        Notify({ type: "warning", message: this.$i18n.t("common.payMethods") });
      } else {
        Toast.loading({
          message: this.$i18n.t("common.payingText"),
          forbidClick: true,
          duration: 0
        });
        api.apiMethod.goPay
          .post(
            {
              checkoutType: 0,
              businessCode: businessCode,
              payProduct: this.checkoutValue,
              merchantPayNo: utils.getUrlSearch("merchantPayNo"),
              extendParam: this.extendParam
              // ip: this.checkoutValue === 3 ? "127.0.0.1" : ""
            },
            {
              checkoutToken: checkoutToken,
              osType: utils.getOsType()
            }
          )
          .then(res => {
            if (res.data.code === 10000) {
              Toast.clear();
              // 支付宝支付
              switch (this.checkoutValue) {
                case 5: {
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  Toast.clear();
                  break;
                }
                case 38:
                case 44:
                case 39:
                case 3: {
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  Toast.clear();
                  console.log("微信支付", url);
                  break;
                }
                case 37: {
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  Toast.clear();
                  console.log("微信公众号支付", url);
                  break;
                }
                case 69:
                case 72: {
                  let url = JSON.parse(JSON.parse(res.data.data.url).nextAction)
                    .url;
                  window.location.href = url;
                  this.queryOrder();
                  break;
                }
                case 11:
                case 46:
                case 27: {
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  console.log("11 Paypal支付 27 支付宝国际");
                  break;
                }
                case 12:
                case 30:
                case 31: {
                  console.log("stripe支付");
                  if (
                    res.data.data.packageParams &&
                    typeof window.Stripe !== "undefined"
                  ) {
                    let packageParams = JSON.parse(res.data.data.packageParams);
                    var stripe = window.Stripe(
                      packageParams.stripePublishableKey
                    );
                    stripe
                      .redirectToCheckout({
                        sessionId: packageParams.stripeSessionId
                      })
                      .then(function(result) {
                        console.log(result);
                      });
                  }
                  break;
                }
                case 58:
                case 59: {
                  let nextActionUrl = JSON.parse(
                    JSON.parse(res.data.data.url).nextAction
                  ).url;
                  console.log("nextActionUrl", nextActionUrl);
                  window.location.href = nextActionUrl;
                  this.queryOrder();
                  break;
                }
                case 42: {
                  console.log("stripe-H5支付");
                  if (
                    res.data.data.packageParams &&
                    typeof window.Stripe !== "undefined"
                  ) {
                    let stripeParams = JSON.parse(res.data.data.packageParams);
                    let stripePay = window.Stripe(
                      stripeParams.stripePublishableKey
                    );
                    // let httpDomain = utils.selectEnv();
                    // let returnUrl = httpDomain + "/successResult";
                    console.log(stripePay, "============stripePay===========");
                    stripePay
                      .confirmWechatPayPayment(
                        stripeParams.stripeClientSecret,
                        {
                          payment_method_options: {
                            wechat_pay: {
                              client: "mobile_web"
                            }
                          },
                          return_url: window.location.href
                        }
                        // { handleActions: false }
                      )
                      .then(function(result) {
                        console.log(result, "======result========");
                        // console.log(result, "======result========");
                        // console.log(returnUrl, "======returnUrl========");
                        // console.log(
                        //   stripeParams.stripeClientSecret,
                        //   "======stripeParams.stripeClientSecret========"
                        // );
                        // if ("canceled" === result.paymentIntent.status) {
                        //   window.location.href = "https://www.163.com/";
                        // }
                      })
                      .catch(function(err) {
                        console.log(err, "======err========");
                      });
                  }
                  this.queryOrder();
                  break;
                }
                case 20:
                  console.log("一网通支付");
                  if (res.data.data.packageParams) {
                    this.postHref(
                      CMB_PAY_URL,
                      Base64.decode(res.data.data.packageParams)
                    );
                  }
                  break;
                case 28: {
                  console.log("香港支付宝支付");
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  break;
                }
                case 25: {
                  // paynow
                  Toast.clear();
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.isShowPaynowSheet = true;
                  let options = {
                    text: res.data.data.packageParams,
                    width: 150,
                    height: 150,
                    colorDark: "#90137B",
                    colorLight: "#FFFFFF",
                    dotScale: 1,
                    quietZone: 12,
                    quietZoneColor: "#FFFFFF",
                    logo: this.paynowImg,
                    logoWidth: 36,
                    logoHeight: 36
                  };
                  this.$nextTick(() => {
                    new QRCode(this.$refs.qrcodeRef, options);
                  });
                  this.queryOrder();
                  break;
                }
                case 49:
                  this.handlePaymentCase(49, res);
                  break;
                case 51:
                  this.handlePaymentCase(51, res);
                  break;
                case 63:
                  this.handlePaymentCase(63, res);
                  break;
                case 75:
                  // 调起stripe apple pay
                  this.stripeApplePay(75, res, this.stripePublishableKey);
                  break;
                case 78:
                  // 调起stripe google pay
                  this.stripeGooglePay(78, res, this.stripePublishableKey);
                  break;
                default:
                  break;
              }
            } else {
              Toast.clear();
              this.payStatusResult(2);
            }
          });
      }
    },
    init() {
      this.setGoodInfo();
      // 获取本地存储的语言，默认为英语
      const storedLang = localStorage.getItem("lang") || "en";

      // 根据本地存储的语言设置当前语言
      if (storedLang === "en") {
        this.languageTitle = "English";
        this.$i18n.locale = "en";
        this.languagekey = "0";
      } else if (storedLang === "zh") {
        this.languageTitle = "简体中文";
        this.$i18n.locale = "zh";
        this.languagekey = "1";
      } else if (storedLang === "fr") {
        this.languageTitle = "Français";
        this.$i18n.locale = "fr";
        this.languagekey = "2";
      } else if (storedLang === "ja") {
        this.languageTitle = "日本語";
        this.$i18n.locale = "ja";
        this.languagekey = "3";
      } else if (storedLang === "ko") {
        this.languageTitle = "한국어";
        this.$i18n.locale = "ko";
        this.languagekey = "4";
      }

      // 自动关闭语言选择器下拉菜单的点击事件
      document.addEventListener("click", this.handleDocumentClick);
    },

    // 处理文档点击事件关闭语言选择器
    handleDocumentClick(event) {
      const selector = document.querySelector(".mobile-language-selector");
      if (selector && !selector.contains(event.target)) {
        this.showLanguageOptions = false;
      }
    },
    isInWeixin() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    /**
     * @method handleAirwallexSuccess
     * @description 处理Airwallex支付成功
     */
    handleAirwallexSuccess(result) {
      console.log("Airwallex payment success:", result);
      // 查询订单状态
      this.queryOrder();
    },

    /**
     * @method handleAirwallexError
     * @description 处理Airwallex支付错误
     */
    handleAirwallexError(error) {
      console.error("Airwallex payment error:", error);
      // Toast.fail(error.message);
      // 可以添加错误处理逻辑
      this.payStatusResult(2);
      this.reportLog({
        eventId: "PAYERROR_PC",
        msg: this.checkoutValue
      });
    },

    /**
     * @method handleAirwallexInitialized
     * @description 处理Airwallex初始化完成
     */
    handleAirwallexInitialized() {
      console.log("Airwallex initialized successfully");
      this.loading = false;
    }
  },
  beforeDestroy() {
    // 移除各种事件监听器，防止内存泄漏
    document.removeEventListener("click", this.handleDocumentClick);
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>
<style lang="less">
.moblieContent {
  width: 100%;
  height: 100%;
  position: relative;
  .payBtnBox {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.16rem 0.4rem;
    background: #fff;
    box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.08);
    .payBtn {
      width: 100%;
      height: 0.88rem;
      text-align: center;
      line-height: 0.88rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: #ffaa0a;
      border-radius: 0.44rem;
    }
  }
  .moblieBox {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 1.2rem;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    .line {
      height: 0.2rem;
      background: rgba(248, 248, 248, 1);
    }
    .topInfo {
      position: relative;
      background: #ffaa0a;
      .title {
        text-align: center;
        font-size: 0.36rem;
        height: 1rem;
        line-height: 1rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .div_shown_close_button {
        position: absolute;
        left: 10px;
        top: 10px;
        z-index: 10;

        .div_close_button {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.2);
          transition: all 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
          }

          .close-icon {
            color: #fff;
            font-size: 10px;
            font-weight: bold;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .div_select_right {
        position: absolute;
        right: 10px;
        top: 10px;
        .mobile-language-selector {
          position: relative;
          width: 100px;

          .selected-language {
            padding: 5px 10px;
            border-radius: 8px;
            background: #ffaa0a;
            color: #fff;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            i {
              margin-left: 5px;
            }
          }

          .language-options {
            position: absolute;
            right: 0;
            top: 110%;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            z-index: 100;
            min-width: 120px;

            .language-option {
              padding: 10px 15px;
              cursor: pointer;
              text-align: center;
              transition: all 0.2s;

              &:hover {
                background: #f5f5f5;
              }

              &.active {
                background: #f5f5f5;
                color: #333;
              }
            }
          }
        }
      }
      .changeLangBtn {
        i {
          display: inline-block;
          position: absolute;
          top: 0.1rem;
          left: 0.16rem;
          width: 0.36rem;
          height: 0.36rem;
          background-image: url("../../assets/mobile/switch_icon.png");
          background-size: cover;
        }
        position: absolute;
        right: 0;
        top: 0.22rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 1rem 0 0 1rem;
        height: 0.28rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        padding: 0.14rem 0.3rem 0.14rem 0.6rem;
      }
      .amountInfo {
        text-align: center;
        padding: 0.4rem 0 0.7rem;
        color: rgba(255, 255, 255, 1);
        .moneyInfo {
          .currency {
            font-size: 0.32rem;
            vertical-align: middle;
            margin-right: 0.08rem;
          }
          .totalfee {
            font-weight: 600;
          }
          vertical-align: middle;
          display: inline-block;
          font-size: 0.48rem;
        }
        .timeInfo {
          span {
            display: inline-block;
            margin-right: 0.12rem;
          }
          margin-top: 0.3rem;
          font-size: 0.28rem;
          font-weight: 400;
        }
      }
      .botLine {
        width: 100%;
        position: absolute;
        bottom: -0.03rem;
        left: 0;
        height: 0.3rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.3rem 0.3rem 0 0;
      }
    }
    .fffContainer {
      overflow: auto;
    }
    .fffContainer::-webkit-scrollbar {
      display: none;
    }
    .goodInfo {
      padding: 0.1rem 0.4rem 0.4rem;
      background-color: #fff;
      font-weight: 400;
      .title {
        font-size: 0.28rem;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 0.2rem;
      }
      .goodName,
      .goodDes {
        font-size: 0.32rem;
        color: rgba(51, 51, 51, 1);
        line-height: 0.48rem;
      }
      .goodName {
        margin-bottom: 0.4rem;
      }
    }
    .payMethod {
      padding: 0.4rem 0.4rem 2.4rem 0.4rem;
      background-color: #fff;
      font-weight: 400;
      font-size: 0.28rem;
      color: rgba(102, 102, 102, 1);
      .title {
        margin-bottom: 0.4rem;
      }
      .payAll {
        width: 100%;
        .tip {
          color: #969799;
          font-size: 12px;
          line-height: 18px;
          padding-right: 0.8rem;
        }
      }
      .payPart {
        display: flex;
        align-items: center;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // height: 0.68rem;
        padding: 0.1rem 0;
        i {
          display: inline-block;
          height: 0.68rem;
          margin-right: 0.2rem;
          img {
            height: 100%;
            vertical-align: middle;
          }
        }
        .text {
          display: block;
          .van-cell {
            padding: 0 !important;
            font-size: 0.28rem;
            font-weight: 400;
            // height: 0.68rem;
            line-height: 1.2;
          }
        }
      }
      .radioBox {
        .van-radio__icon--checked .van-icon {
          background-color: #ffaa0a;
          border-color: #ffaa0a;
        }
      }
    }

    .dialogBox {
      width: 5.9rem;
      text-align: center;
      border-radius: 0.12rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
        display: block;
        margin: 0.5rem auto 0.2rem;
      }
      p {
        padding: 0 50px;
      }
      .van-dialog__content {
        margin-bottom: 0.5rem;
      }
      .van-dialog__footer {
        border-top: 0.01rem solid rgba(226, 226, 226, 1);
        .van-button__text {
          font-weight: 600;
        }
      }
    }
  }
  .paynow-action-sheet {
    .header {
      box-sizing: border-box;
      height: 1rem;
      background: #f8f8f8;
      padding: 0 0.3rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 1rem;
      .div_left {
        float: left;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        img {
          vertical-align: middle;
          margin-right: 12px;
        }
      }
      .div_right {
        float: right;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-top: 2px;
          cursor: pointer;
          background: url("../../assets/pc/fork_popup.svg") no-repeat;
          background-size: 100%;
        }
        span:hover {
          background: url("../../assets/pc/fork_popup_hower.svg") no-repeat;
          background-size: 100%;
        }
      }
    }
    .centerContent {
      text-align: center;
      padding-top: 0.38rem;
      padding-bottom: 0.6rem;
      .botText {
        text-align: center;
        font-size: 0.28rem;
        font-weight: 400;
        color: #333;
        line-height: 0.4rem;
        padding: 0 0.5rem;
        & + .botText {
          margin-top: 0;
        }
        span {
          font-weight: 500;
          color: #ffaa0a;
        }
      }
      .save-button {
        width: 3rem;
        height: 0.88rem;
        border-radius: 0.14rem;
        border: 1px solid #ffaa0a;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffaa0a;
        background: #fff;
        margin: 23px 0 30px;
      }
    }
  }
}
.popup-content {
  padding: 0.2rem 0.4rem 0.5rem;
  .popup-title {
    font-size: 0.32rem;
    font-weight: 600;
    color: #333;
    line-height: 0.44rem;
    padding: 0.3rem 0;
    text-align: center;
  }
}
.adyen-checkout__content-separator,
#molpay_ebanking_fpx_MY-container .adyen-checkout__field {
  display: none;
}
.adyen-checkout__issuer-button-group {
  display: block !important;
  .adyen-checkout__issuer-button {
    width: 100%;
    border: none !important;
    box-shadow: none !important;
    border-bottom: 1px solid #e2e2e2 !important;
    border-radius: 0 !important;
    height: 56px !important;
    .adyen-checkout__issuer-button-img {
      max-height: 20px;
    }
    .adyen-checkout__issuer-button-text {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .adyen-checkout__issuer-button--selected {
    color: #ffaa0a !important;
  }
}

.airwallex-popup-content {
  padding: 1.2rem 0.4rem 0.5rem;
}
.googleOrApplePayButton {
  width: 260px;
  height: 40px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  margin: 32px auto 0;
}
.googleOrApplePayButton-wrap, .stripeExpressCheckoutButton-wrap {
  flex-wrap: wrap;
  padding-top: 40px;
  text-align: center;
  .tips {
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
}
.loading-img {
  width: 30px;
  height: 30px;
  margin: 32px auto 0;
  -webkit-transform: rotate(360deg);
  animation: rotation 2s linear infinite;
  -moz-animation: rotation 2s linear infinite;
  -webkit-animation: rotation 2s linear infinite;
  -o-animation: rotation 2s linear infinite;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.stripeExpressCheckoutButton {
  padding: 20px;
}
</style>
